@let current = page();
@let totalCount = totalPages();

<button [disabled]="current <= 1"
        (click)="page.set(page() - 1); scrollToTarget()"
        class="s1-pagination--nav">
    <span class="absolute"><</span>
</button>

<button
    class="s1-pagination--index s1-pagination--index__is-active">
    <span class="absolute">{{current}}</span>
</button>

<button [disabled]="current >= totalCount"
        (click)="page.set(page() + 1); scrollToTarget()"
        class="s1-pagination--nav">
    <span class="absolute">></span>
</button>
